import { PaginationState } from '@apps/clos-sessions/shared/pagination/types';
import { ClosAssetDTO } from './types.dto';
import { BinaryId as ClosAssetGUID } from './assets-local-storage';

export { BinaryId as ClosAssetGUID } from './assets-local-storage';

export enum ClosArchiveBucket {
  sharing = 'sharing',
  session = 'session',
}

export interface ClosBucketState {
  /** Basically, it contains of archive ID and {@link ClosBucketState.type} */
  id: string;
  state: PaginationState;
  type: ClosArchiveBucket;
}

export interface ClosAsset {
  id: string;

  url: string;

  previewUrl: string;

  name: string;

  guid?: ClosAssetGUID;

  bucket: ClosArchiveBucket;

  archiveId: string;

  /** from 1 to 10 */
  rate: number;

  // techdebt https://github.com/CLOS-Inc/CLOS_Frontend/issues/408
  /** @deprecated - need to support deprecated module {@link ViewPhotoComponent} */
  dto: ClosAssetDTO;

  createdAt: {
    date: string;
    timestamp: number;
  };
}

export interface ClosAssetUploading {
  id: ClosAssetGUID;

  status: ClosUploadStatus;

  archiveId: string;

  name: string;

  bucket: ClosArchiveBucket;

  progress: {
    percent: number;
    bytesUploaded: number;
    totalBytes: number;
  };
}

export enum ClosUploadStatus {
  awaiting = 'awaiting',
  inProgress = 'inProgress',
  success = 'success',
  error = 'error',
}
